import { Text } from '@fluentui/react/lib/Text';
import { PrimaryButton, Icon, IComboBoxOption } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../../../../system';
import MessageCourier from '../../../../../lib/MessageCourier';
import { t } from 'i18next';
import { LiquidacionInsumo } from '../../../../../system/settlement/aje/liquidacion-insumos';
import { DateTime } from 'luxon';
import { User } from '../../../../../system/User';
import { LiquidacionAsincronaV2 } from '../../../../../system/liquidacion_asincrona/LiquidacionAsincronaV2System';
interface IGenerateSettlement {
  setButtonDisability?: any;
  system: TimeTaxSupportSystemClient;
  dataTable: LiquidacionInsumo[] | undefined | null;
  courier: MessageCourier;
  generatedSettlementResponse: LiquidacionAsincronaV2 | undefined;
  generateSettlement: () => void;
  settlementType: IComboBoxOption;
  from: DateTime;
  user: User;
}

const GenerateSettlement = (props: IGenerateSettlement) => {
  const period = () => {
    if (props.dataTable && props.dataTable[0]) {
      return props.dataTable[0].liqins_periodo;
    }
  };

  return (
    <div>
      <div className="ms-Grid mt-2" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col  ms-sm6">
            <div className="ms-Grid-col  ms-sm12 mt-1 ">
              <Text>
                {' '}
                <Icon iconName="PublicCalendar" /> {t(' Período a liquidar:') + ' ' + period()}
              </Text>
            </div>
            <div className="ms-Grid-col  ms-sm12 mt-1 ">
              <Text>
                {' '}
                <Icon iconName="TableComputed" /> {t(' Tipo de liquidación:') + ' ' + props.settlementType.text}
              </Text>
            </div>
            <div className="ms-Grid-col  ms-sm12 mt-1 ">
              <Text>
                {' '}
                <Icon iconName="Clock" /> {t(' Fecha de inicio del proceso:') + ' ' + props.from.toFormat('dd/MM/yyyy hh:mm:ss a')}
              </Text>
            </div>
            <div className="ms-Grid-col  ms-sm12 mt-1 ">
              <Text>
                {' '}
                <Icon iconName="ReminderPerson" /> {t(' Generado por:') + ' ' + props.user.getCollaborator().fullName()}
              </Text>
            </div>
            {!props.generatedSettlementResponse && (
              <div className="ms-Grid-col  ms-sm12 mt-4">
                <PrimaryButton text={t('Generar liquidacion')} onClick={props.generateSettlement} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateSettlement;
